import RangeSlider from "./components/RangeSlider.vue";

export function install(Vue) {
  Vue.component("rangeSlider", RangeSlider);
}
const plugin = {
  install
};

export default plugin;
